/** @format */

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_category } from "../store/reducers/homeReducer";

export const useCategories = () => {
  const dispatch = useDispatch();
  const { categories, loading, errorMessage, clientLocation } = useSelector(
    (state) => state.home,
  );

  useEffect(
    () => {
      if (categories.length === 0) {
        // Fetch only if not already loaded
        dispatch(get_category());
      }
    },
    [dispatch, categories.length],
    clientLocation,
  );

  return { categories, loading, errorMessage, clientLocation };
};
